export const globalType = {
    SET_ALERT: 'SET_ALERT',
    RESET_STORE: 'RESET_STORE',
};